import React from "react";
import Cart_header from "./header";
import Order_list from "../component-mini-cart/component-order-list";
import Total_cart from "./total-cart";
import { Link } from "react-router-dom";
import { useCartStore } from "../../store/useCartStore";

function Cart_content() {
  const { shopping, loading } = useCartStore((state) => state);

  return (
    <div id="cart">
      <Cart_header />
      <Order_list />
      <Total_cart />
      {shopping.total_items !== 0 ? (
        <div className="container">
          <div className="row">
            <div className="col-12">
              <Link to="/checkout" className="checkout">
                تسویه حساب
              </Link>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default Cart_content;
